"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _datePicker = _interopRequireDefault(require("../datePicker"));
var _FormContext = _interopRequireDefault(require("./FormContext"));
var _FormInput = _interopRequireDefault(require("./FormInput"));
const FormDate = _ref => {
  let {
    value,
    placeholder,
    className,
    readOnly,
    icon,
    modalPicker,
    mode,
    required,
    // TODO: handle required
    state,
    minDate,
    // TODO: Handle min and max for input
    maxDate,
    managed,
    onChange,
    onFocus,
    onBlur
  } = _ref;
  const {
    controlId,
    isFocus,
    required: inputIsRequired,
    // TODO: Handle required in association with state prop
    onBlur: onInputBlur,
    onFocus: onInputFocus,
    onRequiredChange,
    setState
  } = _react.default.useContext(_FormContext.default);
  const [showCalendar, setShowCalendar] = _react.default.useState(false);
  const internalValueOptions = _react.default.useMemo(() => ({
    locked: managed !== true && isFocus
  }), [isFocus, managed]);
  const [internalValue, setInternalValue] = (0, _arkReact.useInternalValueManager)(value, internalValueOptions);
  const [textValue, setTextValue] = (0, _arkReact.useInternalValue)((0, _ark.isDate)(value) ? (0, _ark.formatDate)(value) : '');
  _react.default.useEffect(() => setState?.(state), [state]);
  _react.default.useEffect(() => onRequiredChange?.(required ?? false), [required, onRequiredChange]);
  const handleInputChange = _react.default.useCallback((newValue, event) => {
    let inputValue = newValue;
    if (inputValue.length === 2 && inputValue[1] !== '/' || inputValue.length === 5 && inputValue[4] !== '/') {
      inputValue += '/';
    } else if (inputValue[inputValue.length - 1] === '/') {
      inputValue = inputValue.substring(0, inputValue.length - 1);
    }
    const newDate = (0, _ark.parseDate)(inputValue);
    if (newDate !== null && (0, _ark.isDate)(internalValue)) {
      newDate.setHours(internalValue.getHours());
      newDate.setMinutes(internalValue.getMinutes());
      newDate.setSeconds(internalValue.getSeconds());
      newDate.setMilliseconds(internalValue.getMilliseconds());
    }
    setInternalValue(newDate ?? undefined);
    onChange?.(newDate ?? undefined, event);
    setTextValue(inputValue);
  }, [internalValue, onChange, setTextValue, setInternalValue]);
  const handleDatePickerChange = _react.default.useCallback((newDate, event) => {
    event.stopPropagation();
    setInternalValue(newDate);
    if ((0, _ark.isDate)(newDate)) setTextValue((0, _ark.formatDate)(newDate));else setTextValue('');
    setShowCalendar(false);
    if ((0, _ark.isFunction)(onBlur)) onBlur(newDate, event);
    if ((0, _ark.isFunction)(onChange)) onChange(newDate, event);
  }, [setInternalValue, setShowCalendar, onBlur, setTextValue, onChange]);
  const handleDataPickerClose = _react.default.useCallback(() => {
    setShowCalendar(false);
    onInputBlur?.();
    onBlur?.(internalValue, undefined);
  }, [onInputBlur, onBlur, internalValue, setShowCalendar]);
  const handleInputBlur = _react.default.useCallback((_value, event) => {
    if (showCalendar) return;
    onInputBlur?.();
    onBlur?.(internalValue, event);
  }, [onInputBlur, onBlur, internalValue, showCalendar]);
  const handleInputFocus = _react.default.useCallback(event => {
    if (readOnly === true) return;
    setShowCalendar(true);
    onInputFocus?.();
    onFocus?.(event);
  }, [onInputFocus, onFocus, readOnly]);
  const inputIsReadonly = _react.default.useMemo(() => readOnly || mode === 'picker', [readOnly, mode]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "formInputWrapper"
  }, /*#__PURE__*/_react.default.createElement(_FormInput.default, {
    icon: icon,
    readOnly: inputIsReadonly,
    value: textValue ?? '',
    onChange: handleInputChange,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur
  }), showCalendar && /*#__PURE__*/_react.default.createElement(_datePicker.default, {
    modal: modalPicker,
    value: internalValue ?? undefined,
    anchorEl: controlId,
    minDate: minDate,
    maxDate: maxDate,
    onChange: handleDatePickerChange,
    onClose: handleDataPickerClose
  }));
};
process.env.NODE_ENV !== "production" ? FormDate.propTypes = {
  value: _propTypes.default.instanceOf(Date),
  className: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  mode: _propTypes.default.oneOf(['all', 'picker', 'input']),
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date),
  modalPicker: _propTypes.default.bool,
  icon: _propTypes.default.node,
  managed: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func
} : void 0;
FormDate.defaultProps = {
  value: undefined,
  className: undefined,
  placeholder: undefined,
  readOnly: undefined,
  mode: undefined,
  modalPicker: undefined,
  icon: undefined,
  managed: false,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined
};
var _default = exports.default = FormDate;